(function () {

  "use strict";



  // --- 1. GLOBAL HELPERS (Accessible by ALL buttons on the site) ---



  window.updateQuantity = function(id, qty, variantId) {

    // Enforce stock ceiling from global registry

    if (variantId != null && window.tvStockMap) {

      var _max = window.tvStockMap[String(variantId)];

      if (_max != null && qty > _max) qty = _max;

    }

    if (qty < 0) qty = 0;

    fetch('/cart/change.js', {

      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify({ id: id, quantity: parseInt(qty) })

    })

    .then(res => {

      if (!res.ok) return fetch('/cart.js').then(r => r.json());

      return res.json();

    })

    .then(cart => { window.renderCart(cart); })

    .catch(err => fetch('/cart.js').then(r => r.json()).then(c => window.renderCart(c)));

  };



  window.addProduct = function(variantId) {

    fetch('/cart/add.js', {

      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify({ items: [{ id: String(variantId), quantity: 1 }] })

    }).then(res => res.json()).then(() => {

      fetch('/cart.js').then(res => res.json()).then(cart => window.renderCart(cart));

    });

  };



  // Internal helper — does the actual /cart/add.js POST

  function _tvDoAdd(variantId, btn) {

    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    fetch('/cart/add.js', {

      method: 'POST',

      headers: { 'Content-Type': 'application/json' },

      body: JSON.stringify({ id: Number(variantId), quantity: 1 }),

    }).then(function() {

      if (btn) btn.textContent = 'Added!';

      fetch('/cart.js').then(function(res) { return res.json(); }).then(function(cart) {

        window.renderCart(cart);

        if (window.openCartDrawer) window.openCartDrawer();

        setTimeout(function() { if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; } }, 2000);

      });

    }).catch(function() { if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; } });

  }



  window.toylviaAddToCart = function(variantId, btn) {

    // Disable button immediately to block rapid double-clicks

    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }



    // 1. Seed tvStockMap from button's data-stock if this product isn't known yet

    //    (covers collection page adds where product-main.liquid never ran)

    if (btn && btn.dataset && btn.dataset.stock !== undefined) {

      var ds = parseInt(btn.dataset.stock, 10);

      // Safety net: data-stock="0" means OOS — block the add

      if (ds === 0) {

        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }

        return;

      }

      if (ds > 0) {

        if (!window.tvStockMap) window.tvStockMap = {};

        if (window.tvStockMap[String(variantId)] == null) {

          window.tvStockMap[String(variantId)] = ds;

        }

      }

    }



    // 2. If we know the stock cap, check live cart qty before adding

    var _max = (window.tvStockMap && window.tvStockMap[String(variantId)] != null)

      ? window.tvStockMap[String(variantId)] : null;



    if (_max === null) {

      // No cap data available — add freely

      _tvDoAdd(variantId, btn);

      return;

    }



    // Fetch live cart to get current qty for this variant

    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {

      var inCart = 0;

      cart.items.forEach(function(item) {

        if (String(item.variant_id) === String(variantId)) inCart = item.quantity;

      });

      if (inCart >= _max) {

        // Already at cap — open drawer to show current state, don't add

        window.renderCart(cart);

        if (window.openCartDrawer) window.openCartDrawer();

        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }

        return;

      }

      _tvDoAdd(variantId, btn);

    }).catch(function() { _tvDoAdd(variantId, btn); });

  };



  // --- 2. TITLE CLEANER ---



  window.cleanProductTitle = function(t) {

    return t

      .replace(/Toy\s*[Ii]via|Toylvia|TOYLVIA/g, '')   // brand variants

      .replace(/([a-zA-Z])(\d)/g, '$1 $2')              // Set1012 → Set 1012

      .replace(/(\d)([A-Z]{2,})/g, '$1 $2')                 // 1012PCS → 1012 PCS

      .replace(/\s*\d+\s*pcs\b/gi, '')                  // remove piece counts

      .replace(/\s*\|\s*/g, ' ')

      .replace(/\s{2,}/g, ' ')

      .trim();

  };



  // Apply to all product card titles on page load and after DOM changes

  function _cleanAllTitles() {

    document.querySelectorAll('.product-card__title:not([data-tc])').forEach(function(el) {

      el.textContent = window.cleanProductTitle(el.textContent);

      el.setAttribute('data-tc', '1');

    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', _cleanAllTitles);

  } else {

    _cleanAllTitles();

  }

  /* TLV-BATCH-TITLE-CLEANUP-20261023 */
  var _titleCleanQueued = false;
  var _titleObs = new MutationObserver(function(muts) {
    if (_titleCleanQueued) return;
    var hasTitles = muts.some(function(m) { return Array.prototype.some.call(m.addedNodes, function(n) {
      return n.nodeType === 1 && (n.matches('.product-card__title:not([data-tc])') || n.querySelector('.product-card__title:not([data-tc])'));
    }); });
    if (!hasTitles) return;
    _titleCleanQueued = true;
    setTimeout(function(){ _titleCleanQueued = false; _cleanAllTitles(); }, 0);
  });

  _titleObs.observe(document.documentElement, { childList: true, subtree: true });

  // Disconnect after page finishes loading — titles are all cleaned by then

  window.addEventListener('load', function() { setTimeout(function() { _titleObs.disconnect(); }, 2000); });



  // --- 3. THE MASTER RENDERER (Builds the UI) ---



window.renderCart = function(cart) {

  var container = document.getElementById("cartDrawerItems");

  var total = document.getElementById("cartDrawerTotal");

  var upsell = document.getElementById("cartUpsell");

  var clearBtn = document.getElementById("clearCartBtn");

  var urgencyMsg = document.getElementById("cartUrgency");



  var _count = cart ? (cart.item_count || 0) : 0;

  var _badge = document.querySelector('[data-cart-count]');

  if (_badge) { _badge.textContent = _count; _badge.style.display = _count > 0 ? 'flex' : 'none'; }

  var _price = document.querySelector('[data-cart-price]');

  if (_price) { _price.textContent = '$' + ((cart ? cart.total_price : 0) / 100).toFixed(2); _price.style.display = _count > 0 ? 'inline' : 'none'; }

  var _freeShip = document.getElementById('cartFreeShipMsg');

  if (_freeShip) { _freeShip.style.display = _count > 0 ? 'flex' : 'none'; }



  if (!container || !cart) return;



  // 1. GLOBAL URGENCY MESSAGE

  if (urgencyMsg) {

    var messages = ["", ""];

    urgencyMsg.innerHTML = `<div style="color:#ff4fa3; font-weight:700; font-size:13px; padding-bottom:10px; text-align:center;">${messages[Math.floor(Math.random() * messages.length)]}</div>`;

  }



  // 2. CLEAR ALL LOGIC

  if (clearBtn) {

    clearBtn.onclick = function(e) {

      e.preventDefault(); e.stopPropagation();

      if (confirm('Clear entire cart?')) fetch('/cart/clear.js', { method: 'POST' }).then(() => fetch('/cart.js').then(r => r.json()).then(cart => window.renderCart(cart)));

    };

  }



  // 3. RENDER MAIN ITEMS

  window._tvImgCache = window._tvImgCache || {};



  container.innerHTML = (cart.items || []).map(item => {

    var imgUrl = item.image || (item.featured_image ? item.featured_image.url : '');

    var handle = item.handle || (item.url ? item.url.split('/products/')[1].split('?')[0] : '') || '';



    const timeBucket = Math.floor(Date.now() / 300000);

    const seed = `toylvia-${item.product_id}:${timeBucket}`;

    let hash = 5381;

    for (let i = 0; i < seed.length; i++) { hash = (hash * 33) ^ seed.charCodeAt(i); }

    const randomCount = (Math.abs(hash) % 31) + 15;



    var stockLabel = item.quantity > 5

      ? `<span style="color:#e67e22; font-size:11px; font-weight:700;">(Limited Stock)</span>`

      : `<span style="color:#888; font-size:11px;">(Qty: ${item.quantity})</span>`;



    // Stock cap: disable + when at the registered max for this variant

    var _maxQty = (window.tvStockMap && window.tvStockMap[String(item.variant_id)] != null)

      ? window.tvStockMap[String(item.variant_id)] : Infinity;

    var _atMax = _maxQty !== Infinity && item.quantity >= _maxQty;

    var _plusBtn = _atMax

      ? `<button class="cart-qty-btn" disabled style="width:32px;height:32px;background:none;border:none;box-shadow:none;cursor:not-allowed;font-size:16px;font-weight:900;color:#1a1a2e;display:flex;align-items:center;justify-content:center;padding:0;opacity:0.3;">+</button>`

      : `<button class="cart-qty-btn" onclick="event.stopPropagation(); window.updateQuantity('${item.key}', ${item.quantity + 1}, ${item.variant_id})" style="width:32px;height:32px;background:none;border:none;box-shadow:none;cursor:pointer;font-size:16px;font-weight:900;color:#1a1a2e;display:flex;align-items:center;justify-content:center;padding:0;">+</button>`;



    var cleanTitle = window.cleanProductTitle(item.product_title);

    return `

      <div style="display:flex;gap:12px;border-bottom:1px solid #f0f0f0;padding:14px 0;">

        <img src="${imgUrl}" ${handle ? 'data-handle="'+handle+'"' : ''} width="60" height="60" style="border-radius:12px;object-fit:cover;flex-shrink:0;">

        <div style="flex:1;min-width:0;">

          <div style="font-size:13px;font-weight:700;line-height:1.35;">${cleanTitle}</div>

          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:11.5px;color:#888;margin-top:2px;font-weight:500;">${item.variant_title}</div>` : ''}

          <div style="color:#888;font-size:11px;font-weight:700;margin-top:2px;">${randomCount} people have this in their cart</div>

          <div style="display:flex;align-items:center;gap:10px;margin-top:8px;">

            <div style="display:inline-flex;align-items:center;border:2px solid #1a1a2e;border-radius:999px;background:#fff;overflow:hidden;">

              <button class="cart-qty-btn" onclick="event.stopPropagation(); window.updateQuantity('${item.key}', ${item.quantity - 1})" style="width:32px;height:32px;background:none;border:none;box-shadow:none;cursor:pointer;font-size:16px;font-weight:900;color:#1a1a2e;display:flex;align-items:center;justify-content:center;padding:0;">−</button>

              <span style="padding:0 8px;font-weight:800;font-size:13px;color:#111;">${item.quantity}</span>

              ${_plusBtn}

            </div>

            <span style="font-weight:800;font-size:14px;color:#111;">$${(item.line_price / 100).toFixed(2)}</span>

            ${stockLabel}

          </div>

        </div>

      </div>`;

  }).join('') || '<div style="text-align:center;padding:2rem;color:#888;">Your cart is empty.</div>';



  // Async: replace variant images with primary product images

  (cart.items || []).forEach(function(item) {

    var handle = item.handle || (item.url ? item.url.split('/products/')[1].split('?')[0] : '') || '';

    if (!handle) return;

    var cache = window._tvImgCache;

    function applyImg(src) {

      var imgs = container.querySelectorAll('img[data-handle="' + handle + '"]');

      imgs.forEach(function(img) { if (src) img.src = src; });

    }

    if (cache[handle]) { applyImg(cache[handle]); return; }

    if (cache[handle] === null) return;

    cache[handle] = null;

    fetch('/products/' + handle + '.json')

      .then(function(r) { return r.json(); })

      .then(function(d) {

        var src = d.product && (

          (d.product.images && d.product.images[0] && d.product.images[0].src) ||

          (d.product.featured_image && d.product.featured_image.src)

        );

        if (src) { cache[handle] = src; applyImg(src); }

      }).catch(function() {});

  });





  // 5. BUNDLE UPSELL — only render once per cart open, don't re-randomize on qty changes

  if (upsell && cart.item_count > 0 && upsell.dataset.loaded !== '1') {

    upsell.dataset.loaded = '1';

    var cartProductIds = (cart.items || []).map(function(i) { return i.product_id; });

    var productId = cartProductIds[0];

    if (productId) {

      fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')

        .then(function(r) { return r.json(); })

        .then(function(data) {

          var products = (data.products || []).filter(function(p) { return cartProductIds.indexOf(p.id) === -1 && p.available; });

          if (!products.length) { upsell.innerHTML = ''; return; }

          var pick = products[Math.floor(Math.random() * Math.min(products.length, 4))];

          var variant = pick.variants && pick.variants[0];

          if (!variant) { upsell.innerHTML = ''; return; }

          var img = pick.featured_image || (pick.images && pick.images[0] ? pick.images[0].src : '');

          var origPrice = parseInt(variant.price) / 100;

          var discPrice = (origPrice * 0.85).toFixed(2);

          var upsellTitle = pick.title.replace(/toylvia/gi,'').replace(/\s*\|\s*/g,' ').replace(/\s{2,}/g,' ').trim();

          upsell.innerHTML = '<div class="cart-bundle"><div class="cart-bundle__label">Bundle & Save</div><div class="cart-bundle__row"><img class="cart-bundle__img" src="' + img + '" alt=""><div class="cart-bundle__info"><div class="cart-bundle__title">' + upsellTitle + '</div><div class="cart-bundle__price"><span style="text-decoration:line-through;color:#bbb;">$' + origPrice.toFixed(2) + '</span> <strong style="color:#16a34a;">$' + discPrice + '</strong></div></div><button class="cart-bundle__add" onclick="event.stopPropagation(); window.addProduct(\'' + variant.id + '\'); this.textContent=\'Added!\';">Add</button></div></div>';

        })

        .catch(function() { upsell.innerHTML = ''; });

    } else {

      upsell.innerHTML = '';

    }

  } else if (cart.item_count === 0 && upsell) {

    upsell.innerHTML = '';

    upsell.dataset.loaded = '';

  }



  var subtotal = cart.total_price / 100;

  var subtotalEl = document.getElementById('cartSubtotalAmt');

  var shippingEl = document.getElementById('cartShippingAmt');

  if (subtotalEl) subtotalEl.textContent = '$' + subtotal.toFixed(2);

  if (shippingEl) { shippingEl.textContent = cart.item_count > 0 ? 'FREE' : '-'; shippingEl.className = cart.item_count > 0 ? 'free' : ''; }

  if (total) total.textContent = '$' + subtotal.toFixed(2);

};



  // --- 3. INITIALIZATION & DRAWER LOGIC ---



  document.addEventListener("DOMContentLoaded", function () {

    initCartDrawer();

    initProductGallery();

  });



  function initCartDrawer() {

    var drawer = document.querySelector(".cart-drawer");

    var overlay = document.querySelector(".cart-overlay");

    if (!drawer) return;



    window.openCartDrawer = function() {

      drawer.classList.add("open");

      if (overlay) overlay.classList.add("open");

      fetch("/cart.js").then((res) => res.json()).then(window.renderCart);

    };



    function closeDrawer() {

      drawer.classList.remove("open");

      if (overlay) overlay.classList.remove("open");

    }



    document.querySelectorAll("[data-cart-open]").forEach((btn) => {

      btn.addEventListener("click", (e) => { e.preventDefault(); window.openCartDrawer(); });

    });



    document.querySelectorAll("[data-cart-close]").forEach((btn) => {

      btn.addEventListener("click", closeDrawer);

    });



    if (overlay) overlay.addEventListener("click", closeDrawer);

  }



  function initProductGallery() {

    var main = document.getElementById("mainProductImage");

    if (!main) return;

    document.querySelectorAll(".product-thumb").forEach(t => {

      t.onclick = () => (main.src = t.dataset.full);

    });

  }

})();



// free shipping bar removed — all orders ship free



// === CRO: REWARD TIMER ===

window.startRewardTimer = function() {

  var el = document.getElementById('rewardTimer');

  if (!el || el._running) return;

  el._running = true;

  el.style.display = 'block';

  var timeEl = el.querySelector('.reward-timer__time');

  var seconds = 10 * 60;

  function tick() {

    if (!timeEl) return;

    var m = Math.floor(seconds / 60);

    var s = seconds % 60;

    timeEl.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;

    if (seconds > 0) { seconds--; setTimeout(tick, 1000); }

    else { timeEl.textContent = '00:00'; el.style.opacity = '0.5'; }

  }

  tick();

};



// === CRO: URGENCY MESSAGE ===

window.initUrgency = function() {

  var el = document.getElementById('pdpUrgency');

  if (!el || el._shown) return;

  var productId = el.dataset.productId || 'x';

  // Day-stable: same number for same product all day, persists on page revisit

  var dayBucket = Math.floor(Date.now() / 86400000);

  var seed = 'urgency-' + productId + ':' + dayBucket;

  var hash = 5381;

  for (var i = 0; i < seed.length; i++) { hash = (hash * 33) ^ seed.charCodeAt(i); }

  hash = Math.abs(hash);

  var count = (hash % 20) + 8; // 8–27

  var msgs = [count + ' people are looking at this right now', 'Only a few left at this price!'];

  var msg = msgs[(hash >> 3) % msgs.length];

  el._shown = true;

  el.innerHTML = '<div class="pdp-urgency"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#555" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>' + msg + '</div>';

  el.style.display = 'block';

};



// === CRO: APPLY BUNDLE DISCOUNT ===

window.applyBundleDiscount = function() {

  var btn = document.getElementById('cartCheckoutBtn');

  if (btn && btn.href && btn.href.indexOf('discount=') === -1) {

    btn.href = '/checkout?discount=BUNDLE15';

  }

};



// === PRODUCT PAGE INIT (urgency) ===

(function() {

  function pdpInit() { window.initUrgency && window.initUrgency(); }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', pdpInit);

  } else {

    pdpInit();

  }

})();



// ── VARIANT PICKER ───────────────────────────────────────────────

function selectVariant(btn, variantId, priceFormatted) {

  var input = document.getElementById('selected-variant-id');

  if (input) input.value = variantId;

  var priceEl = document.getElementById('productPrice');

  if (priceEl) priceEl.textContent = priceFormatted;

  var picker = document.getElementById('variant-picker');

  if (picker) {

    picker.querySelectorAll('.variant-btn').forEach(function(b) {

      b.style.background = '#fff';

      b.style.border = '2px solid #e5e7eb';

      b.style.color = '#1a1a2e';

      b.style.fontWeight = '500';

    });

  }

  btn.style.background = 'rgba(255,42,148,0.08)';

  btn.style.border = '2px solid rgb(255,42,148)';

  btn.style.color = 'rgb(255,42,148)';

  btn.style.fontWeight = '700';

}

document.addEventListener('DOMContentLoaded', function() {

  var first = document.querySelector('#variant-picker .variant-btn:not([disabled])');

  if (first) first.click();

});





// === SPHERE ICON RANDOM IDLE ANIMATION ===

(function () {

  var INTERVAL    = 5000;   // ms between triggers

  var DURATION    = 700;     // ms each animation plays

  var lastIndex   = -1;      // avoid repeating same sphere twice



  // Each entry: [CSS animation-name, keyframe definition]

  var animations = [

    // Bounce up & back

    ['_sph-bounce', '@keyframes _sph-bounce{0%,100%{transform:translateY(0) scale(1)}30%{transform:translateY(-14px) scale(1.08)}60%{transform:translateY(4px) scale(0.95)}80%{transform:translateY(-6px) scale(1.03)}}'],

    // Wiggle / shake

    ['_sph-wiggle', '@keyframes _sph-wiggle{0%,100%{transform:rotate(0deg)}15%{transform:rotate(-18deg)}35%{transform:rotate(16deg)}55%{transform:rotate(-10deg)}75%{transform:rotate(8deg)}90%{transform:rotate(-4deg)}}'],

    // Pop scale pulse

    ['_sph-pop',    '@keyframes _sph-pop{0%,100%{transform:scale(1)}25%{transform:scale(1.35)}50%{transform:scale(0.85)}75%{transform:scale(1.15)}}'],

    // Spin quarter-turn and back

    ['_sph-spin',   '@keyframes _sph-spin{0%{transform:rotate(0deg) scale(1)}40%{transform:rotate(180deg) scale(1.1)}70%{transform:rotate(340deg) scale(0.95)}100%{transform:rotate(360deg) scale(1)}}'],

    // Tada (scale + tilt)

    ['_sph-tada',   '@keyframes _sph-tada{0%,100%{transform:scale(1) rotate(0deg)}10%,90%{transform:scale(0.9) rotate(-3deg)}20%,80%{transform:scale(1.2) rotate(3deg)}30%,50%,70%{transform:scale(1.25) rotate(-3deg)}40%,60%{transform:scale(1.25) rotate(3deg)}}'],

  ];



  // Inject keyframes once into a style tag

  var styleEl = document.createElement('style');

  animations.forEach(function(a){ styleEl.textContent += a[1]; });

  // Base rule: icon should transition back smoothly after animation

  document.head.appendChild(styleEl);



  function pickSphere() {

    var icons = document.querySelectorAll('.category-sphere__icon');

    if (!icons.length) return;



    // Weighted random: pick any index != lastIndex

    var idx;

    var attempts = 0;

    do {

      idx = Math.floor(Math.random() * icons.length);

      attempts++;

    } while (idx === lastIndex && attempts < 10);

    lastIndex = idx;



    var icon = icons[idx];

    var sphere = icon.closest('.category-sphere');



    // Skip if sphere is being hovered

    if (sphere && sphere.matches(':hover')) return;



    // Pick a random animation

    var anim = animations[Math.floor(Math.random() * animations.length)];

    var animName = anim[0];



    // Apply

    icon.style.animation = animName + ' ' + DURATION + 'ms cubic-bezier(0.36,0.07,0.19,0.97) both';



    // Clean up after animation finishes

    setTimeout(function() {

      icon.style.animation = '';

    }, DURATION + 50);

  }



  // Start the interval after DOM is ready

  function init() {

    // First fire after one full interval

    var timer=null;
    function visible(){var target=document.querySelector('.category-sphere');if(!target)return false;var r=target.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight;}
    function sync(){if(document.hidden||!visible()){if(timer){clearInterval(timer);timer=null;}return;}if(!timer)timer=setInterval(pickSphere,INTERVAL);}
    document.addEventListener('visibilitychange',sync);window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync,{passive:true});sync();

  }



  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', init);

  } else {

    init();

  }

})();









// === ALL PRODUCTS BUTTON RANDOM IDLE ANIMATION ===

(function () {

  var INTERVAL  = 15000;

  var DURATION  = 1100;

  var STROKE_DUR = 1800;

  var lastAnim   = '';

  var animNames = ['_sph-bounce','_sph-wiggle','_sph-pop','_sph-spin','_sph-tada'];

  var GRAD_ON  = 'linear-gradient(rgb(249,250,251),rgb(249,250,251)) padding-box, linear-gradient(135deg,#ff2994,#21d5ed) border-box';

  var GRAD_OFF = 'linear-gradient(rgb(249,250,251),rgb(249,250,251)) padding-box, linear-gradient(135deg,transparent,transparent) border-box';

  function pickBtnAnim() {

    var btn = document.querySelector('.all-products-btn');

    if (!btn) return;

    if (btn.matches(':hover')) return;

    var pool = animNames.filter(function(a){ return a !== lastAnim; });

    var animName = pool[Math.floor(Math.random() * pool.length)];

    lastAnim = animName;

    btn.style.animation = animName + ' ' + DURATION + 'ms cubic-bezier(0.25,0.46,0.45,0.94) both';

    btn.style.transition = 'background 0.6s ease-in-out';

    btn.style.background = GRAD_OFF;

    setTimeout(function() { btn.style.background = GRAD_ON; }, STROKE_DUR);

    setTimeout(function() { btn.style.animation = ''; btn.style.transition = ''; btn.style.background = ''; }, STROKE_DUR + 400);

  }

  function init() {
    var timer=null;
    function visible(){var target=document.querySelector('.all-products-btn');if(!target)return false;var r=target.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight;}
    function sync(){if(document.hidden||!visible()){if(timer){clearInterval(timer);timer=null;}return;}if(!timer)timer=setInterval(pickBtnAnim,INTERVAL);}
    document.addEventListener('visibilitychange',sync);window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync,{passive:true});sync();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

})();

// === TRUST ICON RANDOM IDLE ANIMATION ===

(function () {

  var INTERVAL  = 6000;

  var DURATION  = 700;

  var lastIndex = -1;

  var lastAnim  = '';

  var animNames = ['_sph-bounce','_sph-wiggle','_sph-pop','_sph-spin','_sph-tada'];

  function pickTrustAnim() {

    var icons = document.querySelectorAll('.trust-badge__icon');

    if (!icons || icons.length === 0) return;

    var pool = [];

    for (var i = 0; i < icons.length; i++) { if (i !== lastIndex) pool.push(i); }

    var idx = pool[Math.floor(Math.random() * pool.length)];

    lastIndex = idx;

    var icon = icons[idx];

    var parent = icon.closest ? icon.closest('.trust-badge') : icon.parentElement;

    if (parent && parent.matches(':hover')) return;

    var animPool = animNames.filter(function(a){ return a !== lastAnim; });

    var animName = animPool[Math.floor(Math.random() * animPool.length)];

    lastAnim = animName;

    icon.style.animation = animName + ' ' + DURATION + 'ms cubic-bezier(0.36,0.07,0.19,0.97) both';

    setTimeout(function() { icon.style.animation = ''; }, DURATION + 50);

  }

  function init() {
    var timer=null;
    function visible(){var target=document.querySelector('.trust-badge__icon');if(!target)return false;var r=target.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight;}
    function sync(){if(document.hidden||!visible()){if(timer){clearInterval(timer);timer=null;}return;}if(!timer)timer=setInterval(pickTrustAnim,INTERVAL);}
    document.addEventListener('visibilitychange',sync);window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync,{passive:true});sync();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

})();



// === SPHERE RIPPLE WAVE — fires every 10s, 0.15s stagger left to right ===

(function() {

  function fireRipple() {

      var spheres = document.querySelectorAll('.category-sphere');

          spheres.forEach(function(sphere, i) {

                setTimeout(function() {

                        var ball = sphere.querySelector('.category-sphere__ball');

                                if (!ball) return;

                                        ball.classList.remove('rippling');

                                                void ball.offsetWidth;

                                                        ball.classList.add('rippling');

                                                                setTimeout(function() { ball.classList.remove('rippling'); }, 800);

                                                                      }, i * 150);

                                                                          });

                                                                            }

                                                                              function init() {
    var timer=null;
    function visible(){var target=document.querySelector('.category-sphere');if(!target)return false;var r=target.getBoundingClientRect();return r.bottom>0&&r.top<innerHeight;}
    function sync(){if(document.hidden||!visible()){if(timer){clearInterval(timer);timer=null;}return;}if(!timer)timer=setInterval(fireRipple,10000);}
    document.addEventListener('visibilitychange',sync);window.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync,{passive:true});sync();
  }

                                                                                if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }

                                                                                })();

                                                                                



// === FIX COLLECTION BACK BUTTON ===

(function() {

  var css = '.collection-back-wrapper,.collection-back-btn{display:inline-flex!important}.collection-back-btn{all:unset;display:inline-flex!important;align-items:center;gap:6px;padding:6px 12px 6px 10px;font-family:Nunito,system-ui,sans-serif;font-size:12px;font-weight:700;letter-spacing:.08em;text-transform:uppercase!important;color:#000!important;background:rgba(240,240,245,.6);border-radius:50px;box-shadow:4px 4px 10px rgba(0,0,0,.08),-4px -4px 10px rgba(255,255,255,.85);cursor:pointer;text-decoration:none!important;margin:clamp(6px,2vw,28px) 0 14px 0!important;transition:all .3s ease}.collection-back-btn:hover,.collection-back-btn--pink:hover,.collection-back-btn--yellow:hover,.collection-back-btn--cyan:hover{color:hsl(330,100%,63%)!important;background:rgba(240,240,245,.6)!important;transform:none!important;box-shadow:3px 3px 8px rgba(0,0,0,.08) inset,-3px -3px 8px rgba(255,255,255,.8) inset,0 0 12px rgba(255,42,161,.45),0 0 28px rgba(255,42,161,.2)!important;text-decoration:none!important}.collection-back-btn .back-arrow svg{width:16px;height:16px;stroke-width:2.5;stroke:currentColor;fill:none}.collection-back-btn:hover .back-arrow svg{stroke:hsl(330,100%,63%)}';

  var s = document.createElement('style');

  s.textContent = css;

  document.head.appendChild(s);

  function fixBtns() {

    document.querySelectorAll('.collection-back-btn').forEach(function(b) {

      b.setAttribute('href', 'javascript:history.back()');

    });

  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fixBtns); } else { fixBtns(); }

})();



// === GLOBAL EM-DASH + EMOJI CLEANUP ===

(function() {

  var emojiRe;

  try { emojiRe = new RegExp('\\p{Extended_Pictographic}', 'gu'); } catch(e) {

    emojiRe = /[\u{1F000}-\u{1FFFF}\u{2300}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE00}-\u{FEFF}]/gu;

  }

  function cleanText(root) {

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);

    var node;

    while ((node = walker.nextNode())) {

      var v = node.nodeValue;

      emojiRe.lastIndex = 0;

      if (v.indexOf('—') !== -1 || emojiRe.test(v)) {

        emojiRe.lastIndex = 0;

        node.nodeValue = v.replace(/—/g, '-').replace(emojiRe, '').replace(/  +/g, ' ');

      }

    }

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', function() { cleanText(document.body); });

  } else {

    cleanText(document.body);

  }

})();



// === DESCRIPTION INLINE STYLE CLEANUP ===

function cleanDescStyles() {

  ['#pdc-desc', '#product-desc-wrap'].forEach(function(id) {

    var c = document.querySelector(id);

    if (!c) return;

    var firstEl = c.firstElementChild;

    c.querySelectorAll('*').forEach(function(el) {

      if (firstEl && (el === firstEl || firstEl.contains(el))) return;

      el.removeAttribute('style');

    });

    c.removeAttribute('style');

    if (firstEl) {

      firstEl.style.setProperty('color', '#333', 'important');

      firstEl.querySelectorAll('*').forEach(function(el) {

        el.style.setProperty('color', '#333', 'important');

      });

    }

  });

  document.querySelectorAll('.pdc-badge, .pdc-badge span, .pdc-badge *').forEach(function(el) {

    el.style.setProperty('color', '#1a1a2e', 'important');

    el.style.setProperty('stroke', '#ff42a1', 'important');

  });

  var divider = document.querySelector('.pdc__divider');

  if (divider) divider.style.setProperty('border-top-color', 'rgba(255,66,161,0.25)', 'important');

}

document.addEventListener('DOMContentLoaded', function() {

  cleanDescStyles();

  setTimeout(cleanDescStyles, 200);

  setTimeout(cleanDescStyles, 600);

});



(function() {

  function mobileTitleSize() {

    if (window.innerWidth > 767) return;

    document.querySelectorAll('.product-card__title, .card__heading, .product-card__name').forEach(function(el) {

      el.style.setProperty('font-size', '0.72rem', 'important');

    });

  }

  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', mobileTitleSize);

  } else {

    mobileTitleSize();

  }

})();

// === BACK LINKS GO TO THE PREVIOUS PAGE (2026-10-11) ===
(function(){
  var SEL='.tv-back-shopping,.tlv-wlp__back,.search-page__back,.back-btn,.collection-back-btn';
  document.addEventListener('click',function(e){
    if(e.defaultPrevented||e.button||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var a=e.target.closest&&e.target.closest(SEL);
    if(!a)return;
    var same=false;
    try{same=!!document.referrer&&new URL(document.referrer).origin===location.origin}catch(x){}
    if(same&&history.length>1){e.preventDefault();history.back();}
  },true);
})();

// === tlv-collapsible-filters 2026-10-11: Filter by / Sort by toggle their options ===
(function(){
  var SEL='.home-row-filters__label,.cat-rows__sort-label';
  function init(){
    document.querySelectorAll(SEL).forEach(function(el){
      if(el.getAttribute('data-tlv-collapse'))return;
      el.setAttribute('data-tlv-collapse','1');
      el.setAttribute('role','button');
      el.setAttribute('tabindex','0');
      el.setAttribute('aria-expanded','false');
    });
  }
  function toggle(l){
    var open;
    if(l.classList.contains('home-row-filters__label')){
      var g=l.closest('.home-row-filters');
      if(!g)return;
      open=g.classList.toggle('is-open');
    }else{
      var h=l.closest('.cat-rows__row')||l.closest('.cat-rows__header');
      if(!h)return;
      open=h.classList.toggle('is-sort-open');
    }
    l.setAttribute('aria-expanded',open?'true':'false');
  }
  document.addEventListener('click',function(e){
    var l=e.target.closest&&e.target.closest(SEL);
    if(!l)return;
    e.preventDefault();
    toggle(l);
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter'&&e.key!==' ')return;
    var l=e.target.closest&&e.target.closest(SEL);
    if(!l)return;
    e.preventDefault();
    toggle(l);
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  setTimeout(init,1200);
})();

// === tlv-label-case 2026-10-11: keep row labels in normal case even if the markup is reverted ===
(function(){
  function fix(){
    document.querySelectorAll('.cat-rows__sort-label').forEach(function(e){if(e.firstChild&&e.firstChild.nodeType===3&&/^sort by$/i.test(e.firstChild.nodeValue.trim()))e.firstChild.nodeValue='Sort';});
    document.querySelectorAll('.cat-rows__see-all').forEach(function(e){if(e.firstChild&&e.firstChild.nodeType===3&&/^see all$/i.test(e.firstChild.nodeValue.trim()))e.firstChild.nodeValue='All';});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix);else fix();
  setTimeout(fix,1200);
})();

// === tlv-countdown-right 2026-10-11: move the Halloween countdown next to the up arrow, "19d" -> "19 days" (no flicker) ===
(function(){
  var rewriting=false;
  function place(){
    var c=document.querySelector('.hw-countdown');
    if(!c)return;
    var row=c.closest('.cat-rows__row');
    var bar=row&&row.querySelector('.cat-rows__shuffle-bar');
    if(!bar)return;
    var arrow=bar.querySelector('.tlv-to-top--row');
    if(arrow&&c.nextElementSibling!==arrow)bar.insertBefore(c,arrow);
    else if(!arrow&&c.parentElement!==bar)bar.appendChild(c);
    c.style.setProperty('margin','0 0 0 14px','important');
    c.style.setProperty('order','4','important');
    if(arrow){arrow.style.setProperty('margin-left','0','important');arrow.style.setProperty('order','5','important');}
  }
  function words(){
    if(rewriting)return;
    var c=document.querySelector('.hw-countdown');
    if(!c)return;
    var b=c.querySelector('.hw-h');
    if(!b)return;
    var t=b.textContent.trim(),m=t.match(/^(\d+)d$/);
    if(m){rewriting=true;b.textContent=m[1]+(m[1]==='1'?' day':' days');rewriting=false;}
  }
  function run(){place();words();}
  function watch(){
    var c=document.querySelector('.hw-countdown');
    if(!c||c.getAttribute('data-tlv-watch'))return;
    c.setAttribute('data-tlv-watch','1');
    if(window.MutationObserver){
      // the page script rewrites the text every second; fix it in the same task so it never paints as "19d"
      new MutationObserver(words).observe(c,{childList:true,characterData:true,subtree:true});
    }
  }
  function init(){run();watch();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  setTimeout(init,800);setTimeout(init,2000);
})();

// tlv-row-header-static-geometry-20261022: title and filter placement is owned by first-paint CSS; no timed width rewrite.

// === tlv-new-arrivals-gap 2026-10-11: New Arrivals sits 46px below the plush trio like every other row ===
(function(){
  function fix(){
    var p=document.getElementById('tlv-plush-pair');
    var r=p&&p.nextElementSibling;
    if(r&&r.classList.contains('cat-rows__row'))r.style.setProperty('margin-top','0','important');
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix);else fix();
  setTimeout(fix,800);setTimeout(fix,2000);
})();

// === tlv-coll-grid-spread 2026-10-11: collection cards grow wider (never narrower than 220px) to fill the row edge to edge ===
(function(){
  function fill(){
    var g=document.getElementById('colGrid');
    if(!g)return;
    if(window.innerWidth>=768){
      g.style.setProperty('grid-template-columns','repeat(auto-fill,minmax(220px,1fr))','important');
      g.style.setProperty('justify-content','stretch','important');
      [].slice.call(g.children).forEach(function(c){c.style.setProperty('width','100%','important');c.style.setProperty('max-width','none','important');});
    }else{
      g.style.removeProperty('grid-template-columns');
      g.style.removeProperty('justify-content');
      [].slice.call(g.children).forEach(function(c){c.style.removeProperty('width');c.style.removeProperty('max-width');});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fill);else fill();
  setTimeout(fill,800);setTimeout(fill,2000);
  var t;window.addEventListener('resize',function(){clearTimeout(t);t=setTimeout(fill,150)});
})();

// === tlv-age-pill-calm 2026-10-11: collection pills (ages + types) never fill pink; selected = same look, bold text only ===
(function(){
  var css=''
  +'html body #MainContent#MainContent#MainContent#MainContent .pz-pills .pz-pill,html body #MainContent#MainContent#MainContent#MainContent .pz-pills .pz-pill:hover,html body #MainContent#MainContent#MainContent#MainContent .pz-pills .pz-pill:active,html body #MainContent#MainContent#MainContent#MainContent .pz-pills .pz-pill:focus,html body #MainContent#MainContent#MainContent#MainContent .pz-pills .pz-pill:focus-visible,html body #MainContent#MainContent#MainContent#MainContent .pz-pills .pz-pill.pz-pill--active{background:transparent!important;background-color:transparent!important;color:#666!important;border-color:#e3e3e8!important;box-shadow:none!important;outline:none!important;transition:none!important}'
  +'html body #MainContent#MainContent#MainContent#MainContent .pz-pills .pz-pill:hover{border-color:#cfd2dc!important}'
  +'html body #MainContent#MainContent#MainContent#MainContent .pz-pills .pz-pill.pz-pill--active{font-weight:800!important}'
  +'html body #MainContent#MainContent#MainContent#MainContent .pz-pills .pz-pill:not(.pz-pill--active){font-weight:500!important}'
  +'html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination .page,html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination .page.current,html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination .page:hover,html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination .page:focus,html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination .page:active{background:transparent!important;background-color:transparent!important;color:#374151!important;border-color:#e5e7eb!important;box-shadow:none!important;outline:none!important;transition:none!important}'
  +'html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination .page.current{font-weight:800!important}'
  +'html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination a,html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination .page a,html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination .next a,html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination .prev a,html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination a:hover,html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination a:focus,html body #MainContent#MainContent#MainContent#MainContent .tlv-collection-pagination a:active{background:transparent!important;background-color:transparent!important;box-shadow:none!important;outline:none!important;transition:none!important}';
  function inject(){
    if(document.getElementById('tlv-pills-neutral'))return;
    var s=document.createElement('style');s.id='tlv-pills-neutral';s.textContent=css;
    (document.head||document.documentElement).appendChild(s);
  }
  inject();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',inject);
})();

// === OWNER-REQUESTED STYLES: DO NOT DELETE (2026-10-11) ===
// tlv-owner-overrides.css is linked synchronously in layout/theme.liquid after card-look.css,
// so these rules apply before the browser paints the page.

// === tlv-no-border-separators 2026-10-11: no "|" lines next to Filter / Sort at any width (the theme draws them as border-left) ===
(function(){
  function clean(){
    [].slice.call(document.querySelectorAll('.cat-rows__row .home-row-filters,.cat-rows__row .cat-rows__sort-label,.cat-rows__row .tlv-to-top--row')).forEach(function(e){
      e.style.setProperty('border-left','0','important');
      e.style.setProperty('border-right','0','important');
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',clean);else clean();
  setTimeout(clean,800);setTimeout(clean,2000);
  window.addEventListener('resize',function(){setTimeout(clean,100)});
})();

// === tlv-fs-chevron 2026-10-11: Filter / Sort are light pink; the arrow is a grey > that rotates down when open; no "|" or dash glyphs ===
(function(){var css="html body #MainContent#MainContent#MainContent#MainContent .cat-rows__row .cat-rows__shuffle-bar::before{content:none!important;display:none!important}html body #MainContent#MainContent#MainContent#MainContent .cat-rows__row .home-row-filters__label,html body #MainContent#MainContent#MainContent#MainContent .cat-rows__row .cat-rows__sort-label{color:#ff8fc6!important;display:inline-flex!important;align-items:center!important}html body #MainContent#MainContent#MainContent#MainContent .cat-rows__row .home-row-filters__label::after,html body #MainContent#MainContent#MainContent#MainContent .cat-rows__row .cat-rows__sort-label::after{content:\"\"!important;display:inline-block!important;flex:none!important;width:5px!important;height:5px!important;margin:0 0 0 7px!important;padding:0!important;border:0!important;border-right:1.8px solid #a3a7b8!important;border-bottom:1.8px solid #a3a7b8!important;background:none!important;color:#a3a7b8!important;transform:rotate(-45deg)!important;transition:transform .35s cubic-bezier(.32,.72,0,1)!important}html body #MainContent#MainContent#MainContent#MainContent .cat-rows__row .home-row-filters.is-open .home-row-filters__label::after,html body #MainContent#MainContent#MainContent#MainContent .cat-rows__row.is-sort-open .cat-rows__sort-label::after{transform:rotate(45deg)!important}";function inject(){if(document.getElementById('tlv-fs-chevron'))return;var s=document.createElement('style');s.id='tlv-fs-chevron';s.textContent=css;(document.head||document.documentElement).appendChild(s)}inject();if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',inject);})();

/* tlv-to-top-left: the row's back-to-top arrow sits left of the title, same size (OWNER-REQUESTED, do not remove) */
(function(){
  function mv(){
    document.querySelectorAll('.cat-rows__row').forEach(function(row){
      var t=row.querySelector('.tlv-to-top--row'); if(!t||t.classList.contains('tlv-to-top--left'))return;
      var h=row.querySelector('.cat-rows__header h2'); if(!h)return;
      t.classList.add('tlv-to-top--left'); h.insertBefore(t,h.firstChild); t.style.setProperty('order','-1','important'); t.style.setProperty('margin','0','important'); h.style.setProperty('display','flex','important'); h.style.setProperty('align-items','center','important'); h.style.setProperty('gap','8px','important'); h.classList.add('tlv-title-has-top');
    });
  }
  mv();
})();

/* tlv-toolbar-order: [arrow] Title | Filter | Sort ........ See all (right). OWNER-REQUESTED, do not remove */
(function(){
  var mq=window.matchMedia('(min-width:0px)');
  function ap(){
    document.querySelectorAll('.cat-rows__row').forEach(function(row){
      var bar=row.querySelector('.cat-rows__shuffle-bar'); if(!bar)return;
      function S(e,k,v){if(!e)return; if(mq.matches)e.style.setProperty(k,v,'important'); else e.style.removeProperty(k);}
      S(bar,'justify-content','flex-start');
      var hf=bar.querySelector('.home-row-filters'); S(hf,'order','0'); S(hf,'margin-left','0'); S(hf,'margin-right','0');
      var sl=bar.querySelector('.cat-rows__sort-label'); S(sl,'order','1'); S(sl,'margin-left','0'); S(sl,'margin-right','0');
      bar.querySelectorAll('button.cat-rows__shuffle').forEach(function(b){S(b,'order','2')});
      var sa=bar.querySelector('.cat-rows__see-all'); S(sa,'order','9'); S(sa,'margin-left','auto'); S(sa,'margin-right','0');
      [].forEach.call(bar.children,function(k){
        if(k===sa||k.classList.contains('home-row-filters')||k===sl||k.classList.contains('cat-rows__shuffle')||k.classList.contains('tlv-to-top'))return;
        if(/\bin\s+\d+\s+days?\b/i.test(k.textContent||'')||/countdown/i.test(k.className)){S(k,'order','3'); S(k,'margin-left','14px'); S(sa,'margin-left','14px'); if(window.innerWidth<520){k.style.setProperty('display','none','important');S(sa,'margin-left','auto');}else{k.style.removeProperty('display');}}
      });
    });
  }
  ap();
  if(mq.addEventListener)mq.addEventListener('change',ap); window.addEventListener('resize',ap);
})();


/* TLV-UNIFIED-BACK-ARROW-MOTION */
(function(){
  var id='tlv-unified-back-arrow-motion';
  if(document.getElementById(id))return;
  var style=document.createElement('style');
  style.id=id;
  style.textContent='html body a.collection-back-btn .back-arrow,html body a.back-btn svg,html body a.tv-back-shopping::before,html body a.tlv-wlp__back::before,html body a.search-page__back::before{display:inline-block!important;transition:transform 220ms cubic-bezier(.2,.75,.25,1)!important}html body a.collection-back-btn:hover .back-arrow,html body a.collection-back-btn:focus-visible .back-arrow,html body a.back-btn:hover svg,html body a.back-btn:focus-visible svg,html body a.tv-back-shopping:hover::before,html body a.tv-back-shopping:focus-visible::before,html body a.tlv-wlp__back:hover::before,html body a.tlv-wlp__back:focus-visible::before,html body a.search-page__back:hover::before,html body a.search-page__back:focus-visible::before{transform:translateX(-3px)!important}';
  (document.head||document.documentElement).appendChild(style);
})();

/* TLV-DEFER-CARD-SECONDARY-IMAGES-20261022 */
(function(){
 function loadSecondary(node){
  var card=node&&node.closest&&node.closest('.cr-card,.product-card');if(!card)return;
  var image=card.querySelector('.card-secondary-image[data-src]');if(!image)return;
  var source=image.getAttribute('data-src');if(!source)return;
  image.src=source;image.removeAttribute('data-src');
 }
 document.addEventListener('pointerover',function(e){
  if(e.pointerType==='touch')return;
  if(e.relatedTarget&&e.target.contains&&e.target.contains(e.relatedTarget))return;
  loadSecondary(e.target);
 },{passive:true});
 document.addEventListener('focusin',function(e){loadSecondary(e.target)},{passive:true});
})();

